import styled from 'styled-components'

interface UrlViewStylesProps {
  hasFormat: boolean
  className: string
}

const CAROUSEL_IMG_HEIGHT_MEDIUM = 396
const CAROUSEL_IMG_WIDTH_SMALL = 256
const SLOT_HEIGHT_SMALL = 88
const SLOT_HEIGHT_BIG = 160

export const UrlViewStyles = styled.div<UrlViewStylesProps>`
  background-color: var(--color-white);

  &.url-view {
    .product-detail-container {
      width: fit-content;
    }
  }

  .product-detail__name {
    margin-bottom: var(--spacing-margin-small);
  }

  .prod-detail--default__price {
    margin-bottom: var(--spacing-margin-xSmall);
  }

  .prod-detail--default__order-container {
    margin-top: var(--spacing-margin-medium);
  }

  .product-detail-nxPrice {
    margin-bottom: var(--spacing-margin-xSmall);
  }

  .product-detail-weight {
    margin-bottom: var(--spacing-margin-xSmall);
  }

  .url-view__observations__container {
    height: 66px;
    border-top: #f0f0f0 4px solid;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: auto;
  }

  .observation__txt-btn {
    text-decoration: none;
    color: var(--color-black1);
    font-weight: 400;
    line-height: 20px;
  }

  @media screen and (max-width: 768px) {
    &.modal-view {
      height: inherit;

      .product-detail__figure {
        width: initial;
        margin: 0 8px 8px;
      }

      .url-view__observations__container {
        display: none;
      }
    }

    .product-detail__figure {
      margin-bottom: 0;

      .slick-dots.slick-dots-bottom {
        position: static;
        margin-top: var(--spacing-margin-xSmall);
      }
    }

    .product-detail__figure {
      width: calc(100vw - 32px);
    }

    .carousel__img {
      height: ${CAROUSEL_IMG_HEIGHT_MEDIUM}px;
    }

    .url-view__slot {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 3;
      background-color: var(--color-white);

      height: ${(props) =>
        props.hasFormat ? SLOT_HEIGHT_BIG : SLOT_HEIGHT_SMALL}px;
      box-shadow: 0px -2px 8px rgba(15, 59, 96, 0.09);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: var(--spacing-padding-xlarge);
    }
  }

  @media screen and (max-width: 576px) {
    &.url-view {
      height: 100%;
      overflow-y: auto;
      overflow-x: hidden;
      padding-bottom: ${SLOT_HEIGHT_BIG}px;
      display: block;
    }

    &.modal-view {
      .product-detail-container {
        margin: 0 24px;
        width: auto;
      }

      .product-detail__figure {
        width: 100%;
        margin: 0 0 8px;
      }
    }

    .product-detail-container {
      margin: var(--spacing-margin-medium);
      margin-bottom: 24px;
      width: auto;
      padding: 0;
    }

    .carousel__img {
      height: ${CAROUSEL_IMG_WIDTH_SMALL}px;
    }
  }
`

export const ItemTemplate = styled.div`
  width: 100%;
  max-width: var(--container-max-width-default);
  display: flex;
  flex-direction: column;
  height: 100%;
`
